module.exports = __webpack_public_path__ + "static/media/folder_01_B.3eb56f35.png";